import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { TableHead } from "./ui/table";

// Shared draggable table header cell - pairs with useResizableColumns().
// iter 247: optional click-to-sort. `sortDir` = "asc" | "desc" | null.
export function ResizableTh({ id, width, align, children, onResizeStart, sortable, sortDir, onSort, ...rest }) {
  const right = align === "right";
  return (
    <TableHead
      style={{ width, minWidth: width, maxWidth: width }}
      className={`relative select-none text-[12px] uppercase tracking-wide text-gray-700 font-bold overflow-hidden ${right ? "text-right" : ""} ${sortable ? "cursor-pointer hover:!bg-gray-200/70 transition-colors" : ""}`}
      onClick={sortable ? onSort : undefined}
      data-sort-dir={sortDir || undefined}
      {...rest}
    >
      <span className={`flex items-center gap-0.5 ${right ? "justify-end" : ""}`}>
        <span className="block leading-tight line-clamp-2" style={{ wordBreak: "break-word" }}>{children}</span>
        {sortable && (
          sortDir === "asc" ? <ArrowUp size={11} strokeWidth={2.5} className="shrink-0 text-brand-600" data-testid={`sort-indicator-${id}`} />
          : sortDir === "desc" ? <ArrowDown size={11} strokeWidth={2.5} className="shrink-0 text-brand-600" data-testid={`sort-indicator-${id}`} />
          : <ArrowUpDown size={10} strokeWidth={2} className="shrink-0 text-gray-300" />
        )}
      </span>
      <span
        data-testid={`column-resize-handle-${id}`}
        onMouseDown={onResizeStart}
        onClick={(e) => e.stopPropagation()}
        className="absolute top-0 right-0 h-full w-1.5 cursor-col-resize hover:bg-brand-400/60 active:bg-brand-500"
      />
    </TableHead>
  );
}
